module.exports = __webpack_public_path__ + "static/media/armour_rod.d67a16bb.webp";